export default __webpack_public_path__ + "static/og-image-linux-admin-635a3730635c7d49b891575d09ed6c2d.jpg";